import { createSelector } from '@ngrx/store';
import {
  VistaUsuarioState,
  selectVistaUsuario
} from '../vista-usuario/vista-usuario.state';
import { TramiteState, tramiteAdapter } from './tramite.state';
import { selectEntidadesProductivaFromAuthPersona } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.selectors';
import { Tramite } from './tramite.models';
import { selectCurrentEmpresa } from '../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } = tramiteAdapter.getSelectors();

export const selectTramiteState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tramites
);

export const getError = (state: TramiteState): Error => state.error as any;

export const getIsLoading = (state: TramiteState): boolean => state.isLoading;

export const selectAllTramites = createSelector(selectTramiteState, selectAll);

export const selectEntitiesTramite = createSelector(
  selectTramiteState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTramitesError = createSelector(selectTramiteState, getError);

// MemoizedSelector<object,any>
export const selectTramitesIsLoading = createSelector(
  selectTramiteState,
  getIsLoading
);

export const selectTramiteById = (id: number) =>
  createSelector(selectAllTramites, (allTramites) =>
    allTramites.find((t) => t.id == id)
  );

export const selectTramitesFromCurrentEmpresa = createSelector(
  selectAllTramites,
  selectEntidadesProductivaFromAuthPersona,
  (tramites, currentEmpresa) => {
    let tramitesFromCurrentEmpresa: Tramite[] = [];

    tramites.forEach((t) => {
      currentEmpresa.forEach((e) => {
        if (t.entidad_relacion_id == e.id) {
          tramitesFromCurrentEmpresa.push(t);
        }
      });
    });

    return tramitesFromCurrentEmpresa;
  }
);

export const selectTramiteRegistroEmpresaFromCurrentEmpresa = createSelector(
  selectAllTramites,
  selectCurrentEmpresa,
  (tramites, currentEmpresa) => {
    let tramite: Tramite = null;
    if (tramites && currentEmpresa) {
      tramites.forEach((t) => {
        // Tramite registro empresa
        if (
          t.entidad_relacion_id == currentEmpresa.id &&
          t.tipo_tramite_id == 1
        ) {
          tramite = t;
        }
      });
    }
    return tramite;
  }
);
